module.exports = __webpack_public_path__ + "static/media/IMG_0067.bce7bc16.jpg";